import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'

export const INSTAGRAM_CONNECTION_GUIDE =
  'https://help.blaze.ai/en/articles/9556524-connect-blaze-to-instagram-business'
export const FACEBOOK_CONNECTION_GUIDE = 'https://help.blaze.ai/en/articles/9556524-connect-blaze-to-instagram-business'

export const getConnectionGuide = (provider: ExternalIntegrationEnum) => {
  if (provider === ExternalIntegrationEnum.Instagram) {
    return INSTAGRAM_CONNECTION_GUIDE
  }
  if (provider === ExternalIntegrationEnum.Facebook) {
    return FACEBOOK_CONNECTION_GUIDE
  }
  return null
}
